import { useState } from "react"

import { useEvent } from "./useEvent"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useAsyncAction<TArgs extends any[], TResult>(
  asyncAction?: (...args: TArgs) => TResult
): {
  isLoading: boolean
  execute?: (
    ...args: TArgs
  ) => TResult extends Promise<infer T> ? Promise<T> : void
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useAsyncAction<TArgs extends any[], TResult>(
  asyncAction?: (...args: TArgs) => void | Promise<TResult>
) {
  const [isLoading, setIsLoading] = useState(false)

  const execute = useEvent((...args: TArgs) => {
    const result = asyncAction?.(...args)

    if (result instanceof Promise) {
      setIsLoading(true)
      result.finally(() => {
        setIsLoading(false)
      })
    }

    return result
  })

  return {
    isLoading,
    execute: asyncAction ? execute : undefined
  }
}
